import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RegistersModel } from 'src/app/shared/models/registersModel.model';
import { API_ADMIN_URL, API_URL } from 'src/app/config/api.constant';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private http: HttpClient) { }

  public insertUsertemp(params: RegistersModel) {
    return this.http.post(`${API_ADMIN_URL.insertUsertemp}`, params).pipe(map((res) => res));
  }

  public getHospital() {
    return this.http.get(`${API_URL.getHospital}`).pipe(map((res) => res));
  }

}
